import i18n from "i18next";
import backend from "i18next-xhr-backend";
import detector from "i18next-browser-languagedetector"; 
import { reactI18nextModule } from "react-i18next";
import translationJp from './locales/jp/translationJp.json';
import translationEn from './locales/en/translationEn.json';
import { initReactI18next } from "react-i18next";

const resources ={
    en:{translation:translationEn},
    jp:{translation:translationJp},
}

i18n
  .use(backend)
  .use(detector)
  .use(initReactI18next)
  .init({
      fallbackLng:'en',
      debug:'true',
      detection:{
        order:['queryString','cookie'],
        cache:['cookie']
       },
       interpolation: { escapeValue: false } ,
        resources,
        lng: "en",
        lng: "jp",
        keySeparator: false, 
  });

export default i18n;